import { getApi } from '../apiClient';

// session locale update
export async function setLocale(locale: string): Promise<void> {
  await getApi().post<void>(`/locale`, { locale });
}
